import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InitializerComponent } from './components/initializer/initializer.component';
import { LoginComponent } from './components/login/login.component';
import { TaxonomiesComponent } from './components/taxonomies/taxonomies.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AuthGuard } from './guards/auth.guard';


const routes: Routes = [
  { path: 'initialize', component: InitializerComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'login', component: LoginComponent },

  { path: 'taxonomies', component: TaxonomiesComponent, canActivate: [AuthGuard] },

  { path: '', pathMatch: 'full', redirectTo: '/initialize' },
  { path: '**', redirectTo: '/initialize' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
